import { type RadioGroupOption } from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { type ReactNode } from "react";

export type AllSpecificNoneChoice = "all" | "specific" | "none";

export function getAllSpecificNoneRadioOptions({
  allLabel,
  noneLabel,
  specificLabel,
  specificChildren,
}: {
  allLabel: string;
  noneLabel: string;
  specificLabel: string;
  specificChildren: ReactNode;
}): RadioGroupOption<AllSpecificNoneChoice>[] {
  return [
    { id: "all", label: allLabel },
    {
      id: "specific",
      label: specificLabel,
      children: specificChildren,
      childrenRenderLocation: "bottom",
    },
    { id: "none", label: noneLabel },
  ];
}
